import { useUser } from 'lib/auth';
import { LegalDocumentsAcceptanceDialog } from 'features/legal/components/legal-documents-acceptance-dialog';
import { SubscriptionAcceptanceDialog } from 'features/legal/components/subscription-acceptance-dialog';
import { Skeleton } from 'components/ui/skeleton';

export type OnboardingGuardProps = {
    children: React.ReactNode;
};

export const OnboardingGuard = ({ children }: OnboardingGuardProps) => {
    const { data: user, isLoading } = useUser();

    if (isLoading || !user) {
        return <Skeleton className="h-full w-full" />;
    }

    if (user.requires_legal_document_acceptance) {
        return (
            <LegalDocumentsAcceptanceDialog
                open={true}
                onAccepted={() => {
                    // The mutation will automatically invalidate the user query,
                    // causing this component to re-render with updated user data
                }}
            />
        );
    }

    if (user.requires_subscription_acceptance) {
        return (
            <SubscriptionAcceptanceDialog
                open={true}
                onAccepted={() => {
                    // The user query will be re-fetched automatically when this dialog closes,
                    // since the accept mutation invalidates the subscription query
                }}
            />
        );
    }

    return <>{children}</>;
};
